<!--
 * @Description: 接入IoT设备协议的数量
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 17:05:20
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 09:29:24
 -->
<template>
  <div class="connectIotDevice">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">接入IOT设备协议的数量</span>
    </div>
    <div class="list">
      <div class="item">
        <span class="title">能源管理类</span>
        <el-progress :percentage="connectIotDeviceData.energy * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]]" color="#ff8400" :format="progressFormat(connectIotDeviceData.energy)"></el-progress>
      </div>
      <div class="item">
        <span class="title">多媒体发布</span>
        <el-progress :percentage="connectIotDeviceData.media * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]]" color="#ffff00" :format="progressFormat(connectIotDeviceData.media)"></el-progress>
      </div>
      <div class="item">
        <span class="title">车位管理类</span>
        <el-progress :percentage="connectIotDeviceData.parkingLot * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]]" color="#00ff00" :format="progressFormat(connectIotDeviceData.parkingLot)"></el-progress>
      </div>
      <div class="item">
        <span class="title">安防监控类</span>
        <el-progress :percentage="connectIotDeviceData.SecurityMonitoring * 100 / connectIotDeviceData[Object.keys(connectIotDeviceData)[0]]" color="#03f7f7" :format="progressFormat(connectIotDeviceData.SecurityMonitoring)"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'connectIotDevice',
  components: {
  },
  data () {
    return {
      connectIotDeviceData: {
        energy: 60,
        media: 51,
        parkingLot: 38,
        SecurityMonitoring: 16,
      },
    }
  },
  methods: {
    /**
     * @description                   获取接入IoT设备数据
     * @return {undefied}             无返回值
     */
    getconnectIotDeviceData () {
      this.$http.get('/rest/screen/zhfwq/devices')
        .then(res => {
          if (res.code === 0) {
            console.log(res.data)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   进度条内容格式化
     * @param                         内容
     * @return {undefied}             无返回值
     */
    progressFormat (value) {
      return () => {
        return value.toString()
      }
    },
  },
  created () {
    this.getconnectIotDeviceData()
  },
}
</script>

<style lang="less" scoped>
  .connectIotDevice {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 4vh;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      position: relative;
      >img {
        height: 100%;
        margin-right: 20px;
      }
      .titleName {
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5vh;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #05dbe3;
      }
    }
    .list {
      width: 100%;
      height: 85%;
      overflow-y: scroll;
      .item {
        width: 100%;
        height: 25%;
        display: flex;
        align-items: center;
        .title {
          display: inline-block;
          width: 22%;
          color: #fff;
          vertical-align: middle;
          font-size: 1.5vh;
        }
        /deep/.el-progress {
          display: inline-block;
          width: 78%;
          .el-progress-bar {
            .el-progress-bar__outer {
              background: #1b3134;
            }
          }
          .el-progress__text {
            color: #fff;
          }
        }
      }
    }
  }
</style>
